"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltCallCenter = void 0;
/* eslint-disable max-lines */
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'Call Center Deflection',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: 'ad4062f1-1fae-413c-9d81-5be1b560d31c',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/CallCentreDeflection.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: '882b5a3a-4d37-4941-9c6c-914ed8f4351f',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p><strong>Recipient Details</strong></p>',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '252d3ec9-eecb-412b-919b-dc54ffcc1e20',
            data: {
                backgroundColor: '#ffffff',
                label: 'Full Name',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'text',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '91e4ef44-8c32-492e-b237-d3d9cf65755a',
            data: {
                backgroundColor: '#ffffff',
                label: 'Phone Number',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'tel',
            },
        },
        {
            type: 'form-text-input',
            version: '1',
            id: '73e4484f-0cc3-448a-9d91-db61ef1655aa',
            data: {
                backgroundColor: '#ffffff',
                label: 'Email Address',
                requiredField: true,
                helperText: '',
                defaultValue: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                placeholder: '',
                textInputType: 'email',
            },
        },
        {
            type: 'display-text',
            version: '1',
            id: 'c0171796-ae5e-4672-957a-5440d46ed226',
            data: {
                color: '#000000',
                backgroundColor: '#ffffff',
                textAlign: 'left',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                text: '<p><strong>Template Details</strong></p>',
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '79905cd9-83b8-403f-9cd6-757871140e9a',
            data: {
                backgroundColor: '#ffffff',
                requiredField: true,
                helperText: 'Select a template from the list. A communication path will be executed upon submission specific to the template you have selected.',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: 'Template to send',
                options: [
                    {
                        label: 'Airline - Manage Booking',
                        id: 'a83ccd19-08b9-4f10-9f34-6af7ccf15aa8',
                        value: false,
                    },
                    {
                        label: 'Utility - Payment Options',
                        id: '0ca3c58f-d838-427f-a2b2-30c20ca4c794',
                        value: false,
                    },
                    {
                        label: 'Return to work',
                        id: '48316297-b846-4c55-b4ae-2ebba5f6fc8d',
                        value: false,
                    },
                    {
                        id: '7c7133fb-ed8c-4cbd-89f9-bcb8d2f110d5',
                        label: 'Insurance - Policy Details',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-text-area',
            version: '1',
            id: 'e6c4499d-21be-4ec5-8e87-f62329b72b04',
            data: {
                backgroundColor: '#ffffff',
                label: 'Free Text',
                requiredField: true,
                helperText: 'Text entered here will appear at the bottom of the template that you have selected. You can use this if you need to provide any additional information about the template you are sending.',
                defaultValue: '',
                inputFieldHeight: 4,
                placeholder: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: 'dc0e3ea2-42f7-4eaf-9b44-2ded2a82c20e',
            data: {
                text: 'Send Template',
                color: '#FFFFFF',
                buttonColor: '#7F32DC',
                backgroundColor: '#FFFFFF',
                borderColor: '#7F32DC',
                fontSize: 14,
                borderRadius: 4,
                textAlign: 'center',
                width: 600,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: '252d3ec9-eecb-412b-919b-dc54ffcc1e20',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'First Name',
        },
        {
            id: '91e4ef44-8c32-492e-b237-d3d9cf65755a',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Phone Number',
        },
        {
            id: '73e4484f-0cc3-448a-9d91-db61ef1655aa',
            valueType: 'string',
            inputType: 'form-text-input',
            label: 'Email Address',
        },
        {
            id: '79905cd9-83b8-403f-9cd6-757871140e9a',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: 'Template to send',
            options: [
                {
                    label: 'Airline - Manage Booking',
                    id: 'f13cb812-e828-4649-98fa-108ffbe1bd17',
                    value: false,
                },
                {
                    label: 'Utility - Payment Options',
                    id: '65e9fd56-a823-4d56-bfd7-3b1900c0b39c',
                    value: false,
                },
                {
                    label: 'Return to work',
                    id: '3b4f0dba-6f1d-40b8-b87c-8baebd25cb9a',
                    value: false,
                },
                {
                    id: 'b99ee7b2-0031-4ad7-98ec-350d9d6c4c71',
                    label: 'Insurance - Policy Details',
                    value: false,
                },
            ],
        },
        {
            id: 'e6c4499d-21be-4ec5-8e87-f62329b72b04',
            valueType: 'string',
            inputType: 'form-text-area',
            label: 'Free text',
        },
    ],
};
const prebuiltCallCenter = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        variableName: 'First Name',
                        variableId: '252d3ec9-eecb-412b-919b-dc54ffcc1e20',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Phone Number',
                        variableId: '91e4ef44-8c32-492e-b237-d3d9cf65755a',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Email Address',
                        variableId: '73e4484f-0cc3-448a-9d91-db61ef1655aa',
                        variableType: 'string',
                        type: 'FormTextInput',
                    },
                    {
                        variableName: 'Template to send',
                        variableId: '79905cd9-83b8-403f-9cd6-757871140e9a',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Airline - Manage Booking","checked":"false"},{"id":2,"text":"Utility - Payment Options","checked":"false"},{"id":3,"text":"Return to work","checked":"false"},{"id":"736f07db-5f87-4ab1-ab92-0040f3e26326","text":"Insurance - Policy Details","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: 'Free Text',
                        variableId: 'e6c4499d-21be-4ec5-8e87-f62329b72b04',
                        variableType: 'string',
                        type: 'FormTextArea',
                    },
                ],
            },
            type: 'start',
            next: [
                {
                    id: 5274,
                    type: 'condition',
                    next: [
                        {
                            id: 1105,
                            variables: {
                                input: [],
                                output: [],
                            },
                            type: 'task',
                            action: 'send-sms',
                            next: null,
                            isDirty: true,
                            version: '1.0.4',
                            data: {
                                workspaceId,
                                recipients: [
                                    {
                                        type: 'variable',
                                        stepId: '0',
                                        variableId: '91e4ef44-8c32-492e-b237-d3d9cf65755a',
                                    },
                                ],
                                message: {
                                    content: {
                                        type: 'raw',
                                        subject: '<p>Airline - Manage Booking</p>',
                                        body: '<p>Hi <span data-stepid="0" data-variableid="252d3ec9-eecb-412b-919b-dc54ffcc1e20">First Name</span> ,</p><p></p><p>Due to high demand, we&#x27;re experiencing some delays in call wait times. We thank you for your patience.</p><p></p><p>For standard requests, you can manage your booking from the link below, else a staff member will be in contact with you shortly.</p><p></p><p>https://company.com/manage-booking</p><p></p><p><span data-stepid="0" data-variableid="e6c4499d-21be-4ec5-8e87-f62329b72b04">Free Text</span> </p>',
                                    },
                                    type: 'sms',
                                },
                                link: null,
                                collectResponses: false,
                                stepName: 'Airline - Manage Booking',
                            },
                        },
                    ],
                    action: 'expression',
                    isDirty: true,
                    variables: {
                        input: [],
                        output: [],
                    },
                    version: '1.0.1',
                    data: {
                        stepName: 'IF Condition',
                        expression: {
                            id: '2c93de97-9ad0-4288-bf9f-22a8b1d2bd11',
                            type: 'expression',
                            operator: 'equals',
                            right: {
                                type: 'constant',
                                value: 'Airline - Manage Booking',
                                valueType: 'string',
                            },
                            left: {
                                type: 'variable',
                                variableId: '79905cd9-83b8-403f-9cd6-757871140e9a',
                                stepId: '0',
                            },
                        },
                    },
                },
                {
                    id: 2007,
                    type: 'condition',
                    next: [
                        {
                            id: 3117,
                            variables: {
                                input: [],
                                output: [],
                            },
                            type: 'task',
                            action: 'send-sms',
                            next: null,
                            isDirty: true,
                            version: '1.0.4',
                            data: {
                                workspaceId,
                                recipients: [
                                    {
                                        type: 'variable',
                                        stepId: '0',
                                        variableId: '91e4ef44-8c32-492e-b237-d3d9cf65755a',
                                    },
                                ],
                                message: {
                                    content: {
                                        type: 'raw',
                                        subject: '<p>Utility - Payment Options</p>',
                                        body: '<p>Hi <span data-stepid="0" data-variableid="252d3ec9-eecb-412b-919b-dc54ffcc1e20">First Name</span> ,</p><p></p><p>Thanks for getting in touch with us, we understand the difficulty impacting many people at this time and are providing additional support including payment extensions and payment installment plans.</p><p></p><p>Payment extension</p><p></p><p>https://company.com/payment-extensions</p><p></p><p>Payment Plan</p><p></p><p>https://company.com/payment-plans</p><p></p><p><span data-stepid="0" data-variableid="e6c4499d-21be-4ec5-8e87-f62329b72b04">Free Text</span> </p>',
                                    },
                                    type: 'sms',
                                },
                                link: null,
                                collectResponses: false,
                                stepName: 'Utility - Payment Options',
                            },
                        },
                    ],
                    action: 'expression',
                    isDirty: true,
                    variables: {
                        input: [],
                        output: [],
                    },
                    version: '1.0.1',
                    data: {
                        stepName: 'IF Condition',
                        expression: {
                            id: '3bc24534-6db9-4816-a1d4-db0c8925bce7',
                            type: 'expression',
                            operator: 'equals',
                            right: {
                                type: 'constant',
                                value: 'Utility - Payment Options',
                                valueType: 'string',
                            },
                            left: {
                                type: 'variable',
                                variableId: '79905cd9-83b8-403f-9cd6-757871140e9a',
                                stepId: '0',
                            },
                        },
                    },
                },
                {
                    id: 6087,
                    type: 'condition',
                    next: [
                        {
                            id: 1521,
                            variables: {
                                input: [],
                                output: [],
                            },
                            type: 'task',
                            action: 'send-sms',
                            next: null,
                            isDirty: true,
                            version: '1.0.4',
                            data: {
                                workspaceId,
                                recipients: [
                                    {
                                        type: 'variable',
                                        stepId: '0',
                                        variableId: '91e4ef44-8c32-492e-b237-d3d9cf65755a',
                                    },
                                ],
                                message: {
                                    content: {
                                        type: 'raw',
                                        subject: '<p>Return to Work</p>',
                                        body: '<p>Hi <span data-stepid="0" data-variableid="252d3ec9-eecb-412b-919b-dc54ffcc1e20">First Name</span> ,</p><p></p><p>From our initiatives here at &lt;company&gt;, a healthy workspace for everybody is imperative to our success. As we initiate our return to work plan, we are taking the necessary precautions and implementing safety guidelines to put your safety first.</p><p></p><p>We advise everyone to continue with best practices for hygiene as prescribed by the Health and Safety department.</p><p></p><p><span data-stepid="0" data-variableid="e6c4499d-21be-4ec5-8e87-f62329b72b04">Free Text</span> </p>',
                                    },
                                    type: 'sms',
                                },
                                link: null,
                                collectResponses: false,
                                stepName: 'Return to Work',
                            },
                        },
                    ],
                    action: 'expression',
                    isDirty: true,
                    variables: {
                        input: [],
                        output: [],
                    },
                    version: '1.0.1',
                    data: {
                        stepName: 'IF Condition',
                        expression: {
                            id: '5284d31e-0ff6-4cd3-8d9a-ff5911f854d4',
                            type: 'expression',
                            operator: 'equals',
                            right: {
                                type: 'constant',
                                value: 'Return to work',
                                valueType: 'string',
                            },
                            left: {
                                type: 'variable',
                                variableId: '79905cd9-83b8-403f-9cd6-757871140e9a',
                                stepId: '0',
                            },
                        },
                    },
                },
                {
                    id: 3715,
                    type: 'condition',
                    next: [
                        {
                            id: 4547,
                            variables: {
                                input: [],
                                output: [],
                            },
                            type: 'task',
                            action: 'send-sms',
                            next: null,
                            isDirty: true,
                            version: '1.0.4',
                            data: {
                                workspaceId,
                                recipients: [
                                    {
                                        type: 'variable',
                                        stepId: '0',
                                        variableId: '252d3ec9-eecb-412b-919b-dc54ffcc1e20',
                                    },
                                ],
                                message: {
                                    content: {
                                        type: 'raw',
                                        subject: '<p>Insurance - Policy Details</p>',
                                        body: '<p>Hi <span data-stepid="0" data-variableid="252d3ec9-eecb-412b-919b-dc54ffcc1e20">First Name</span> ,</p><p></p><p>Thanks for enquiring about your insurance policy details. You can find all of the relevant information here:</p><p></p><p>http://company.com/policy</p><p></p><p><span data-stepid="0" data-variableid="e6c4499d-21be-4ec5-8e87-f62329b72b04">Free Text</span> </p>',
                                    },
                                    type: 'sms',
                                },
                                link: null,
                                collectResponses: false,
                                stepName: 'Insurance - Policy Details',
                            },
                        },
                    ],
                    action: 'expression',
                    isDirty: true,
                    variables: {
                        input: [],
                        output: [],
                    },
                    version: '1.0.1',
                    data: {
                        stepName: 'IF Condition',
                        expression: {
                            id: 'ef4b3378-62c6-4d11-8b60-3c48cfc357f6',
                            type: 'expression',
                            operator: 'equals',
                            right: {
                                type: 'constant',
                                value: 'Insurance - Policy Details',
                                valueType: 'string',
                            },
                            left: {
                                type: 'variable',
                                variableId: '79905cd9-83b8-403f-9cd6-757871140e9a',
                                stepId: '0',
                            },
                        },
                    },
                },
            ],
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.prebuiltCallCenter = prebuiltCallCenter;
//# sourceMappingURL=callCenter.js.map